/* unplugin-vue-components disabled */import { render } from "./XAppLayout.vue?vue&type=template&id=5f5241c1&scoped=true"
const script = {}

import "./XAppLayout.vue?vue&type=style&index=0&id=5f5241c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5241c1"]])

export default __exports__